// utils/subscriptionMappings.js
export const FREQUENCY_MAPPING = {
  quarterly: "Quarterly",
  monthly: "Monthly",
  one_time: "One Time",
  yearly: "Yearly",
};

export const DELIVERY_TYPE_MAPPING = {
  pharmacy_pickup: "Pharmacy Pickup",
  mail_delivery: "Mail Delivery",
  pharmacy_pickup_once_then_mail_delivery: "Pharmacy Pickup Then Delivery",
};
